import React from "react";

const STATUS_STYLES = {
  // Table
  available: "bg-emerald-500/15 border-emerald-500/30 text-emerald-300",
  reserved:  "bg-amber-500/15 border-amber-500/30 text-amber-200",
  occupied:  "bg-violet-500/15 border-violet-500/30 text-violet-200",
  cleaning:  "bg-orange-500/15 border-orange-500/30 text-orange-300",
  blocked:   "bg-red-500/15 border-red-500/30 text-red-300",
  inactive:  "bg-zinc-700/40 border-zinc-600/30 text-zinc-400",
  // Ticket
  new:       "bg-emerald-500/15 border-emerald-500/30 text-emerald-300",
  accepted:  "bg-blue-500/15 border-blue-500/30 text-blue-300",
  preparing: "bg-amber-500/15 border-amber-500/30 text-amber-200",
  ready:     "bg-emerald-500/20 border-emerald-400/40 text-emerald-200",
  served:    "bg-zinc-700/40 border-zinc-600/30 text-zinc-400",
  cancelled: "bg-red-500/15 border-red-500/30 text-red-300",
  // Order
  draft:     "bg-zinc-700/40 border-zinc-600/30 text-zinc-300",
  held:      "bg-amber-500/15 border-amber-500/30 text-amber-200",
  submitted: "bg-violet-500/15 border-violet-500/30 text-violet-200",
  in_preparation: "bg-blue-500/15 border-blue-500/30 text-blue-300",
  ready_for_payment: "bg-emerald-500/20 border-emerald-400/40 text-emerald-200",
  partially_paid: "bg-amber-500/15 border-amber-500/30 text-amber-200",
  paid: "bg-emerald-500/20 border-emerald-400/40 text-emerald-200",
  voided: "bg-red-500/15 border-red-500/30 text-red-300",
  refunded: "bg-red-500/15 border-red-500/30 text-red-300",
  closed: "bg-zinc-700/40 border-zinc-600/30 text-zinc-400",
};

export default function StatusBadge({ status, className = "" }) {
  const style = STATUS_STYLES[status] || "bg-zinc-700/40 border-zinc-600/30 text-zinc-300";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-[0.15em] border ${style} ${className}`}
    >
      {(status || "").replace(/_/g, " ")}
    </span>
  );
}
